/**
 * Semáforo de caducidad (inventario de insumos):
 *   ≤ 45 días (o ya caducado) → rojo   (accionar)
 *   46 – 60 días               → amarillo
 *   > 60 días                  → verde
 */
export type ExpiryTone = 'danger' | 'warn' | 'ok' | '';

/** Acepta YYYY-MM-DD, YYYY/MM/DD, DD/MM/YYYY y fechas ISO. */
export function parseExpiry(value: any): Date | null {
  const s = String(value ?? '').trim();
  if (!s) return null;
  let m = s.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  m = s.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1]);
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function daysToExpiry(value: any, today = new Date()): number | null {
  const d = parseExpiry(value);
  if (!d) return null;
  const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((d.getTime() - t.getTime()) / 86_400_000);
}

export function expiryTone(value: any): ExpiryTone {
  const days = daysToExpiry(value);
  if (days === null) return '';
  if (days <= 45) return 'danger';
  if (days <= 60) return 'warn';
  return 'ok';
}

export function expiryHint(value: any): string {
  const days = daysToExpiry(value);
  if (days === null) return '';
  if (days < 0) return `Caducado hace ${-days} día(s)`;
  if (days === 0) return 'Caduca hoy';
  return `Caduca en ${days} día(s)`;
}
